/** @format */

import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Logger } from '@logger';
import { ReviewEvents } from '../model/review.summary.interface';
import { AnalyticsService, CookieService, WINDOW } from '@shared/utils/services';

/** @dynamic */
@Injectable({
	providedIn: 'root'
})
export class ProductReviewAnalyticsService extends AnalyticsService {
	constructor(
		@Inject(DOCUMENT) protected document: Document,
		@Inject(WINDOW) protected window: Window,
		protected cookieService: CookieService,
		protected logger: Logger
	) {
		super(document, window, cookieService, logger);
	}

	fireReviewAnalytics<T>(reviewEvent: ReviewEvents<T>) {
		this.setEventType(reviewEvent.name);
		this.triggerAnalyticsEvent(reviewEvent.name, reviewEvent.payload);
	}
}
